import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GetStockItemsMatListResult, GetStockItemsFGListResult, StockItemSearch, GetStockItemMediumByBigPack, GetStockItemSmallByMedPack, GetStockItemSmallByMedPackSerach, GetStockItemMatForBigBarcode } from '../model/stock-item.model';
import { tap, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';

const API_URL = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

@Injectable()
export class StockItemService {
  private Url = '';  // URL to web api
  currentUser: any;

  constructor(
    private http: HttpClient) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/stockitem';

  }



  GetStockItemsFGList(search: StockItemSearch): Observable<GetStockItemsFGListResult[]> {
    return this.http.post<GetStockItemsFGListResult[]>(this.Url + "/GetStockItemsFGList", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }


  GetStockItemsMatList(search: StockItemSearch): Observable<GetStockItemsMatListResult[]> {
    return this.http.post<GetStockItemsMatListResult[]>(this.Url + "/GetStockItemsMatList", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetStockItemMediumByBigPack(id: number): Observable<GetStockItemMediumByBigPack> {
    return this.http.post<GetStockItemMediumByBigPack>(this.Url + "/GetStockItemMediumByBigPack", id, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }
  GetStockItemMediumByBigPacks(id: number): Observable<GetStockItemMediumByBigPack[]> {
    return this.http.post<GetStockItemMediumByBigPack[]>(this.Url + "/GetStockItemMediumByBigPack", id, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }
  GetStockItemMatForBigBarcode(id: number): Observable<GetStockItemMatForBigBarcode[]> {
    return this.http.post<GetStockItemMatForBigBarcode[]>(this.Url + "/GetStockItemMatForBigBarcode", id, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetStockItemSmallByMedPack(search: GetStockItemSmallByMedPackSerach): Observable<GetStockItemSmallByMedPack[]> {
    return this.http.post<GetStockItemSmallByMedPack[]>(this.Url + "/GetStockItemSmallByMedPack", search, httpOptions)
      .pipe(
        tap(response => {
          // this.log(`fetched `)
        })
      );
  }

  GetStockItemsMatForExport(search: StockItemSearch, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetStockItemsMatForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<StockItemSearch>('SearchWorkPermit'))
    );
  }

  GetStockItemsFGForExport(search: StockItemSearch, type: number): Observable<any> {

    return this.http.post(this.Url + '/GetStockItemsFGForExport/' + type, search, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      responseType: 'arraybuffer'
    }).pipe(tap((x) => {
    }),
      catchError(this.handleError<StockItemSearch>('SearchWorkPermit'))
    );
  }

  /**
       * Handle Http operation that failed.
       * Let the app continue.
       * @param operation - name of the operation that failed
       * @param result - optional value to return as the observable result
       */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a ScgCompanyService message with the MessageService */
  private log(message: string) {
    console.log(message);
    // this.messageService.add('ScgCompanyService: ' + message);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stock-item.service.ts